import dompurify from 'dompurify';

export default {
  install: (Vue) => {
    Vue.prototype.$sanitize = dompurify.sanitize;
  },
};
